export default {"src":"/_next/static/media/pin-red.d3c76a7c.svg","height":51,"width":42,"blurWidth":0,"blurHeight":0};